<template>
  <span class="container" v-clickoutside="handleClose"  id='userDeInput' :name='name'>
    <span class="click-label" :class="{'active': visible,'hq-active': visible&&HQ, 'disable': disabled}" @mouseleave="hide" :style="{height:height, 'line-height': height}" @click="show">
      <span class="text-wrapper" :class="{'auto-width': width === 'auto'}">
        {{text}}
      </span>
      <span class="industry-count" v-if="industryCount">{{industryCount}}</span>
      <i class="el-icon-arrow-down"></i>
    </span>
    <div @mouseenter='clearTimer' @mouseleave="hide" class="click-menu" ref="clickMenu" v-show="visible">
      <slot></slot>
    </div>
  </span>
</template>
<script>
import Clickoutside from 'element-ui/lib/utils/clickoutside';
export default {
  provide () {
    return {
      select: this,
      timerId: null,
    };
  },
  directives: { Clickoutside },
  data () {
    return {
      visible: false,
      timer: null,
    };
  },
  props: ['height', 'text', 'disabled', 'notClose', 'closeFlag','industryCount','name', 'width'],
  methods: {
    show () {
      if (this.disabled) return;
      this.visible = true;
      if(this.name){
        window.sa.quick('trackHeatMap',document.querySelector('#userDeInput'));//第二个参数是发生事件的dom元素
      }
    },
    hide () {
      if (!this.notClose) {
        this.timer = window.setTimeout(() => {
          this.visible = false;
        }, 200);
      }
    },
    clearTimer () {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    },
    handleClose () {
      /*特定类型的点击外部关闭，鼠标移开不关闭*/
      if (this.notClose) {
        window.clearTimeout(this.timerId);
        this.timerId = window.setTimeout(() => {
          /*所在地区增加判断标志*/
          if (this.closeFlag) {
            this.visible = false;
          }
        }, 20);
      }
    },
  },
  mounted () {
    this.$refs.clickMenu.style.top = this.height - 6;
  }
};
</script>
<style lang="scss" scoped>
.container {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
}
.click-label {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  background: #fff;
  border-top: 2px solid #fff;
  transition: all 0.2s;
  cursor: pointer;
  width: 100%;
  .text-wrapper{
    max-width: 105px;//159
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    height: 100%;
    vertical-align: top;
  }
  .industry-count{
    color:var(--theme-color);
    font-weight:400;
    padding: 0 3px 0 8px;
  }
  i {
    margin-left: 5px;
    align-self: center;

  }
  &.active {
    border-top: 2px solid var(--theme-color);
    box-shadow: 0 5px 0px 0px #fff, 0 -1px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 3;
    &.hq-active {
      border-color: #e15151;
      i {
        color: #e15151;
      }
    }
    i {
      color: var(--theme-color);
      transform: rotate(180deg);
    }
  }
  &.disable {
    cursor: not-allowed;
    color: #999;
  }
}
.border-right{
  .click-label{
    display: flex;
    padding: 0 15px;
  }
  i {
    line-height: 50px;
  }
}
.click-menu {
  position: absolute;
  left: 0;
  z-index: 1001;
}
@media (max-width: 1440px) {
  .border-right{
     .click-label {
      padding: 0 9px;
    }
  }
  .text-wrapper{
    max-width: 75px!important;//159
  }
}
@media (max-width: 1280px) {
  .text-wrapper{
    max-width: 60px!important;
  }
  .border-right{
     .click-label {
      padding: 0 8px;
    }
  }
}
@media (max-width: 1024px) {
 .industry-count{
    padding:0!important;
  }
}

.auto-width {
  max-width: none!important;
}
</style>





// WEBPACK FOOTER //
// src/components/clickSelect/index.vue